import * as z from 'zod';
export const ReservationItemPaymentStatus = z.enum(['partially-paid', 'fully-paid', 'unpaid', 'no-payment-required']);
